module.exports = __webpack_public_path__ + "img/diagnostic.b3cb80a9.png";